export const SIDEBAR_WIDTH_COOKIE_NAME = 'sidebar:width';

const SIDEBAR_WIDTH_VALUE_PATTERN = /^\d+(?:\.\d+)?(?:px|rem)$/;
const SIDEBAR_WIDTH_MIN_PX = 280;
const SIDEBAR_WIDTH_MAX_PX = 2000;
const ROOT_FONT_SIZE_PX = 16;

function sidebarWidthToPx(width: string): number | null {
  const parsed = Number.parseFloat(width);
  if (!Number.isFinite(parsed)) {
    return null;
  }

  if (width.endsWith('px')) {
    return parsed;
  }

  if (width.endsWith('rem')) {
    return parsed * ROOT_FONT_SIZE_PX;
  }

  return null;
}

export function resolveSidebarWidth(storedWidth: string | undefined, defaultWidth: string): string {
  if (!storedWidth || !SIDEBAR_WIDTH_VALUE_PATTERN.test(storedWidth)) {
    return defaultWidth;
  }

  const widthPx = sidebarWidthToPx(storedWidth);
  if (widthPx === null || widthPx < SIDEBAR_WIDTH_MIN_PX || widthPx > SIDEBAR_WIDTH_MAX_PX) {
    return defaultWidth;
  }

  return storedWidth;
}

/**
 * Client cookie read for surfaces that paint a sidebar stand-in before the
 * server layout can pass the same value as defaultWidth (e.g. the optimistic
 * PR navigation overlay). SidebarProvider itself only uses the defaultWidth
 * prop so SSR and hydrate stay in sync.
 */
export function getStoredSidebarWidth(defaultWidth: string): string {
  if (typeof document === 'undefined') {
    return defaultWidth;
  }

  const match = document.cookie.match(
    new RegExp(`(?:^|;\\s*)${SIDEBAR_WIDTH_COOKIE_NAME}=([^;]+)`),
  );
  return resolveSidebarWidth(match?.[1], defaultWidth);
}
